import Typography from '@/app/components/typography'
import { Slide } from '@/app/(site)/(static)/about/sections/values/slides'
import { cn } from '@/util/cn'
import ChevronLeftIcon from '@/components/icons/chevron-left-icon'
import ChevronRightIcon from '@/components/icons/chevron-right-icon'

const buttonClassName = cn('cursor-pointer')

type Props = {
    isDisabled: boolean
    onPrev: () => void
    onNext: () => void
} & Pick<Slide, 'name'>

const SlideMobileNavigation = ({ isDisabled, name, onPrev, onNext }: Props) => {
    return (
        <div className="grid w-full grid-cols-[2.5rem_1fr_2.5rem] items-center gap-2">
            <button className={buttonClassName} onClick={onPrev} disabled={isDisabled}>
                <ChevronLeftIcon className="size-7" />
            </button>

            <Typography variant="h2" fontFamily="nexaBlack" className="line-clamp-1 text-center">
                {name}
            </Typography>

            <button className={buttonClassName} onClick={onNext} disabled={isDisabled}>
                <ChevronRightIcon className="size-7" />
            </button>
        </div>
    )
}

export default SlideMobileNavigation
